import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate, Routes, Route, useLocation } from 'react-router-dom';
import { Sidebar } from '../components/dashboard/Sidebar';
import { CampaignCard } from '../components/dashboard/CampaignCard';
import { StatsCard } from '../components/dashboard/StatsCard';
import { ProjectEditorPage } from './ProjectEditorPage';
import { Megaphone, TrendingUp, Eye, MousePointer, Plus, Video, Image } from 'lucide-react';
function DashboardHome() {
  const campaigns = [{
    title: 'Campaña Black Friday',
    description: 'Promoción de descuentos especiales para Black Friday en Facebook e Instagram.',
    lastEdited: 'hace 2 horas',
    status: 'activa' as const,
    platform: 'facebook' as const,
    metrics: {
      impressions: '45.2K',
      clicks: '1.8K',
      ctr: '3.98%'
    }
  }, {
    title: 'Google Ads - Remarketing',
    description: 'Campaña de remarketing para usuarios que visitaron el sitio web.',
    lastEdited: 'hace 1 día',
    status: 'activa' as const,
    platform: 'google' as const,
    metrics: {
      impressions: '120K',
      clicks: '4.5K',
      ctr: '3.75%'
    }
  }, {
    title: 'Video Presentación CEO',
    description: 'Video generado con HeyGen para presentación corporativa del CEO.',
    lastEdited: 'hace 3 días',
    status: 'activa' as const,
    platform: 'heygen' as const
  }, {
    title: 'Imágenes Producto Nuevo',
    description: 'Set de imágenes creadas con Higgsfield para lanzamiento de producto.',
    lastEdited: 'hace 5 días',
    status: 'pausada' as const,
    platform: 'higgsfield' as const
  }, {
    title: 'WhatsApp Marketing',
    description: 'Campaña de mensajes promocionales para base de clientes existentes.',
    lastEdited: 'hace 1 semana',
    status: 'activa' as const,
    platform: 'whatsapp' as const,
    metrics: {
      impressions: '8.5K',
      clicks: '2.1K',
      ctr: '24.7%'
    }
  }, {
    title: 'LinkedIn B2B Campaign',
    description: 'Campaña de generación de leads para servicios empresariales.',
    lastEdited: 'hace 2 semanas',
    status: 'borrador' as const,
    platform: 'linkedin' as const
  }];
  return <div className="max-w-7xl mx-auto space-y-10" data-id="element-210">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-211">
        <div data-id="element-212">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900" data-id="element-213">
            Bienvenido, Administrador
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-214">
            Aquí está el resumen de tus campañas de marketing.
          </p>
        </div>
        <div className="flex items-center gap-3" data-id="element-215">
          <button className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-orange-500 to-pink-500 text-white rounded-xl font-medium hover:opacity-90 transition-all hover:scale-[1.02] active:scale-[0.98]" data-id="element-216">
            <Plus className="w-4 h-4" data-id="element-217" />
            Nueva Campaña
          </button>
        </div>
      </div>

      {/* Stats Row */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6" data-id="element-218">
        <StatsCard label="Campañas Activas" value="8" trend="+2 esta semana" trendUp={true} icon={<Megaphone className="w-5 h-5" data-id="element-220" />} data-id="element-219" />
        <StatsCard label="Impresiones Totales" value="245K" trend="+18% vs mes anterior" trendUp={true} icon={<Eye className="w-5 h-5" data-id="element-222" />} data-id="element-221" />
        <StatsCard label="Clics Totales" value="12.4K" trend="+25% vs mes anterior" trendUp={true} icon={<MousePointer className="w-5 h-5" data-id="element-224" />} data-id="element-223" />
        <StatsCard label="CTR Promedio" value="5.06%" trend="+0.8% vs mes anterior" trendUp={true} icon={<TrendingUp className="w-5 h-5" data-id="element-226" />} data-id="element-225" />
      </div>

      {/* Quick Actions */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-227">
        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="flex items-center gap-4 p-4 bg-gradient-to-r from-purple-500/10 to-blue-500/10 border border-purple-200 rounded-2xl hover:border-purple-300 transition-colors" data-id="element-228">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-purple-500 to-blue-500 flex items-center justify-center text-white" data-id="element-229">
            <Video className="w-6 h-6" data-id="element-230" />
          </div>
          <div className="text-left" data-id="element-231">
            <h3 className="font-bold text-gray-900" data-id="element-232">Crear Video con HeyGen</h3>
            <p className="text-sm text-gray-500" data-id="element-233">
              Genera videos con IA para tus campañas
            </p>
          </div>
        </motion.button>
        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="flex items-center gap-4 p-4 bg-gradient-to-r from-pink-500/10 to-orange-500/10 border border-pink-200 rounded-2xl hover:border-pink-300 transition-colors" data-id="element-234">
          <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-pink-500 to-orange-500 flex items-center justify-center text-white" data-id="element-235">
            <Image className="w-6 h-6" data-id="element-236" />
          </div>
          <div className="text-left" data-id="element-237">
            <h3 className="font-bold text-gray-900" data-id="element-238">
              Crear Imagen con Higgsfield
            </h3>
            <p className="text-sm text-gray-500" data-id="element-239">
              Genera imágenes con IA para tus anuncios
            </p>
          </div>
        </motion.button>
      </div>

      {/* Campaigns Section */}
      <div data-id="element-240">
        <div className="flex items-center justify-between mb-6" data-id="element-241">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-242">Campañas Activas</h2>
          <button className="text-sm font-medium text-orange-600 hover:text-orange-700 hover:underline" data-id="element-243">
            Ver todas las campañas
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-244">
          {campaigns.map((campaign, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: index * 0.1
        }} data-id="element-245">
              <CampaignCard {...campaign} data-id="element-246" />
            </motion.div>)}

          {/* Create New Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: campaigns.length * 0.1
        }} className="group h-full min-h-[280px] border-2 border-dashed border-gray-200 rounded-2xl flex flex-col items-center justify-center text-center p-6 cursor-pointer hover:border-orange-300 hover:bg-orange-50/30 transition-all" data-id="element-247">
            <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-4 group-hover:bg-orange-100 group-hover:scale-110 transition-all" data-id="element-248">
              <Plus className="w-6 h-6 text-gray-400 group-hover:text-orange-500" data-id="element-249" />
            </div>
            <h3 className="font-bold text-gray-900 mb-1" data-id="element-250">
              Crear Nueva Campaña
            </h3>
            <p className="text-sm text-gray-500" data-id="element-251">
              Facebook, Google, WhatsApp o LinkedIn
            </p>
          </motion.div>
        </div>
      </div>
    </div>;
}
export function DashboardPage() {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    if (!isAuthenticated) {
      navigate('/login');
    }
  }, [navigate]);
  // Check if we're on a project editor route
  const isProjectRoute = location.pathname.includes('/dashboard/proyectos/');
  if (isProjectRoute) {
    return <ProjectEditorPage data-id="element-252" />;
  }
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-253">
      <Sidebar data-id="element-254" />
      <main className="flex-1 md:ml-64 p-6 md:p-10" data-id="element-255">
        <DashboardHome data-id="element-256" />
      </main>
    </div>;
}